import Script from 'next/script'

const GA4 = () => {
  const googleAnalyticsCode = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS
  if (!googleAnalyticsCode) return null

  return (
    <>
      <Script async src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsCode}`} />
      <Script id="google-analytics">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleAnalyticsCode}');
        `}
      </Script>
    </>
  )
}

export default GA4
